module.exports = __webpack_public_path__ + "img/img2-bg.bd446c77.png";